import type { ICarUsedAdView } from "@finn-no/adview-provider-frontend-types";
import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "../../../context/AppConfigProviderContext.tsx";
import FieldValuePair from "../FieldValuePair.tsx";

/**
 * The mileage unit type is shared across multiple ad types, so we reuse the type from ICarUsedAdView.
 */
type MileageUnit = ICarUsedAdView["mileage_unit"];

export const Mileage = ({ distance, unit }: { distance?: number; unit?: MileageUnit }) => {
  const { locale } = useAppConfig();
  const { i18n } = useLingui();
  if (distance == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.distance.mileage",
    message: "Mileage",
    comment: "Label for mileage in ad section summary",
  });
  const kmString = i18n.t({
    id: "itemPageLayout.common.distance.kilometer.postfix",
    message: "{distance} km",
    comment: "Distance incl. postfix",
    values: {
      distance: formatNumber(distance, locale),
    },
  });
  const scandinavianMileString = i18n.t({
    id: "itemPageLayout.common.distance.scandinavian_mile.postfix",
    message: "{distance} miles",
    comment: "Distance in scandinavian miles incl. postfix",
    values: {
      distance: formatNumber(distance, locale),
    },
  });

  return <FieldValuePair field={field} value={unit === "SCANDINAVIAN_MILE" ? scandinavianMileString : kmString} />;
};
